import React, { useEffect, useState } from "react";
import { useSnack } from "../../services/SnakbarProvider";
import dayjs from "dayjs";
import Badge from "@mui/material/Badge";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {Box, Typography} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { DayCalendarSkeleton } from "@mui/x-date-pickers/DayCalendarSkeleton";
import { getShipmentList } from "../../api/imports";
import { handleError } from "../../services/errorHandler";

const COMPANY_EMOJIS = {
  1: "🟢",
  2: "🔵",
};

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  // Collect the emojis for every company that has a shipment on this day
  const dayEmojis = outsideCurrentMonth
    ? []
    : Array.from(
        new Set(
          highlightedDays
            .filter((shipment) => shipment.date.isSame(day, "day"))
            .map((shipment) => COMPANY_EMOJIS[shipment.companyId])
            .filter(Boolean)
        )
      );

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      badgeContent={dayEmojis.length ? dayEmojis.join("") : undefined}
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
      />
    </Badge>
  );
}
export default function ShipmentCalendar() {
  const [shipmentDates, setShipmentDates] = useState([]);
  const { openSnack } = useSnack();

  const fetchData = async () => {
    try {
      const res = await getShipmentList({});
      const dates = res.data.map((e) => ({
        date: dayjs(e.portArrivalDate),
        companyId: e.companyId,
      }));
      setShipmentDates(dates);
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        <Typography variant="body2">
          🔵 = Terminados Litográficos
          🟢 = Litografía Gil
        </Typography>
      </Box>
      <DateCalendar
        // sx={{
        //   width: "100%",
        //   height: "100%",
        //   maxHeight: "600px",
        //   // maxWidth: "500px", // or any desired width
        //   "& .MuiPickersDay-root": {
        //     width: "80px", // Increase size of individual day cells
        //     height: "80px",
        //   },
        //   "& .MuiDayCalendar-weekDayLabel": {
        //     width: "80px",
        //   },
        //   "& .MuiDayCalendar-root ": {
        //     height: "600px",
        //     maxHeight: "600px",
        //   },
        //   "& .MuiDayCalendar-viewTransitionContainer": {
        //     height: "600px",
        //     maxHeight: "600px",
        //   },
        //   "& .MuiDayPicker-monthContainer": {
        //     flex: "1 1 auto", // Ensure month container fills available space
        //   },
        //   "& .MuiDayCalendar-slideTransition": {
        //     height: "600px",
        //   },
        //   "& .MuiPickerSlideTransition-root": {
        //     height: "600px",
        //   },
        //   "& .MuiPickersSlideTransition-root": {
        //     height: "600px",
        //   },
        // }}
        renderLoading={() => <DayCalendarSkeleton />}
        slots={{
          day: ServerDay,
        }}
        slotProps={{
          day: {
            highlightedDays: shipmentDates,
          },
        }}
      />
    </LocalizationProvider>
  );
}
